<template>
  <EmFormField
    v-bind="$attrs"
    :label="label"
    :rules="passwordRules"
    :type="type"
    data-cy-form-field="password"
    class="em-password-input"
  >
    <template #append-inner>
      <EmIconButton
        v-if="type === 'password'"
        icon="mdi-eye"
        title="Show password"
        @click="type = 'text'"
      />
      <EmIconButton
        v-if="type === 'text'"
        icon="mdi-eye-off"
        title="Hide password"
        @click="type = 'password'"
      />
    </template>
  </EmFormField>
</template>

<script setup>
const props = defineProps({
  label: { type: String, default: 'Password' },
  required: { default: true, type: Boolean },
  rules: { type: Array, default: () => [] }
})
const type = ref('password')
const { required: requiredRule } = useRules()
const passwordRules = computed(() => {
  const passwordRules = []
  if (props.required) {
    passwordRules.push(requiredRule('password'))
  }
  return [...passwordRules, ...props.rules]
})
</script>

<style lang="scss" scoped>
.em-password-input :deep(.v-field__append-inner) {
  padding: 0 !important;
  align-self: center !important;
}
</style>
